import type { BadgeProps } from "@bowfast/ui/components/badge";
import type { LucideIcon } from "lucide-react";
import { AnchorIcon, CompassIcon, Navigation2Icon, SailboatIcon } from "lucide-react";
import type { RouteType, WaypointKind } from "./routes.types";

// ── Map legend ────────────────────────────────────────────────────────────────

export const LEGEND_ITEMS: ReadonlyArray<{ kind: WaypointKind; label: string; color: string }> = [
  { kind: "depart", label: "Departure", color: "#14b8a6" },
  { kind: "waypoint", label: "Waypoint", color: "#047cc7" },
  { kind: "arrive", label: "Arrival", color: "#f59e0b" },
];

// ── Route type visual config ──────────────────────────────────────────────────

export interface RouteTypeConfig {
  label: string;
  variant: BadgeProps["variant"];
  Icon: LucideIcon;
  lineColor: string;
  glowColor: string;
}

export const TYPE_CONFIG: Record<RouteType, RouteTypeConfig> = {
  ocean: {
    label: "Ocean",
    variant: "active",
    Icon: CompassIcon,
    lineColor: "#047cc7",
    glowColor: "rgba(4,124,199,0.25)",
  },
  offshore: {
    label: "Offshore",
    variant: "planning",
    Icon: Navigation2Icon,
    lineColor: "#2f97d5",
    glowColor: "rgba(47,151,213,0.2)",
  },
  coastal: {
    label: "Coastal",
    variant: "open",
    Icon: AnchorIcon,
    lineColor: "#14b8a6",
    glowColor: "rgba(20,184,166,0.25)",
  },
  inland: {
    label: "Inland",
    variant: "draft",
    Icon: SailboatIcon,
    lineColor: "#94a3b8",
    glowColor: "rgba(148,163,184,0.15)",
  },
};
